import styled from 'styled-components'

import { Header1 } from '~design-system'

const JobTitle = styled(Header1)`
  font-size: 1.5rem;
`

export default JobTitle
